import MatchImage from './MatchImage'

export default MatchImage
